module.exports = __webpack_public_path__ + "img/mobile-des.6a959461.png";